import { InternalGalleryVisibilityPayload } from './types';
import { GalleryVisibilityState } from '../../../../widgets/gallery/enums';
import { InternalMessageType } from '../../enums';
import { InternalMessagePayloadValidator } from '../../types';

export const internalGalleryVisibilityMessagePayloadValidator: InternalMessagePayloadValidator<
  InternalMessageType.GalleryVisibility
> = (payload: unknown): payload is InternalGalleryVisibilityPayload =>
  !!payload &&
  typeof payload === 'object' &&
  'state' in payload &&
  Object.values(GalleryVisibilityState).includes(
    payload.state as GalleryVisibilityState
  );
